import * as React from "react";
import { connect } from "react-redux";

import AddToSavedButton from "../../page-framework/add-to-saved-button";
import { SVG } from "../../../component-configuration/svgs";
import { Person, Entity, GRAPHQL_TYPE_PERSON, GRAPHQL_TYPE_ENTITY } from "@radivision/graphql";
import { HeaderMoreMenu } from "./more-menu";
import { AppState } from "../../../redux";
import { EditProfileButton } from "./edit-profile-button";
import { isOwner } from "../../../utilities/is-owner";

interface ComponentProps {
  value: Person | Entity;
  onChangeModalTitle: (s: string) => void;
  resetProfileDetails: () => void;
}

interface MapStateProps {
  user: Person;
}

export type Props = ComponentProps & MapStateProps;

export const Component = (props: Props) => {
  const { value: subject, user } = props;
  const owner = isOwner(subject, user);
  return (
    <Container>
      {!owner && <AddToSavedButton item={subject} label="Follow" className="profile-header-follow action-button" />}

      {owner && <EditProfileButton subject={subject} />}
      <MoreMenu subject={subject} onChangeModalTitle={() => {}} user={user} />
    </Container>
  );
};

const mapState = (state: AppState) => ({
  user: state.account.user,
});

export const XLProfileHeaderActions = connect(mapState)(Component);

const Container = ({ children }) => {
  return <div className="xl-profile-actions">{children}</div>;
};

const MoreMenu = ({ user, subject, onChangeModalTitle }) => {
  const isPerson = subject?.__typename === GRAPHQL_TYPE_PERSON;
  const isCompany = subject?.__typename === GRAPHQL_TYPE_ENTITY;
  const owner = isOwner(subject, user);
  const showMoreMenu = !owner && ((isPerson && !user) || isCompany) && subject?.isClaimable;
  if (!showMoreMenu) {
    return null;
  }
  return (
    <span className="more-menu">
      <HeaderMoreMenu subject={subject} onChangeModalTitle={onChangeModalTitle} />
    </span>
  );
};
// <a
//   className="more-dropdown"
//   href="#"
//   id="profile-more-menu"
//   role="button"
//   data-toggle="dropdown"
//   aria-haspopup="true"
//   aria-expanded="false"
// >
//   {children}
// </a>
// {false && <DropMenu {...props} />}

const DropMenu = ({ owner }) => {
  return (
    <div className="dropdown-menu" aria-labelledby="profile-more-menu">
      {owner && (
        <a className="dropdown-item" data-toggle={`modal`} data-target={"#editProfileModal"}>
          Edit Profile
        </a>
      )}
    </div>
  );
};
